import React from 'react'
import styled from 'styled-components'

import _ from 'lodash'
import moment from 'moment'
import 'moment/locale/ko'

import { Timeline as TwitterTimeline } from 'react-twitter-widgets'

const sizes = { w: 300, h: 440 }

const Container = styled.section`
  position: relative; box-sizing: border-box;
  width: 96%; max-width: 96%;
  margin: 0 auto;
`

const Header = styled.header`
  position: relative; box-sizing: border-box;
  padding: 2rem 0.5rem;
  & > div.lead { font-size: 1.6em; margin-bottom: 0.15rem; }
  & > div.desc { padding: 0.5rem 0; opacity: 0.6; }
`

const Box = styled.div`
  position: relative; box-sizing: border-box;
  width: ${`${sizes.w}px`}; height: ${`${sizes.h}px`};
  min-width: ${`${sizes.w}px`}; min-height: ${`${sizes.h}px`};
  margin: 10px;
`

Box.Group = styled.div`
  position: relative; box-sizing: border-box;
  display: flex; overflow: auto;
  width: 100%; max-width: 100%;
  min-height: ${`${sizes.w * 1.1}px`};
`

// 3분마다 리프레시 될 수 있도록 해둔다.
class LiveTwittersWidget extends React.Component {
  constructor(props) {
    super(props)

    this.timer = null
    this.abortController = new AbortController()

    this.initialize = this.initialize.bind(this)
    this.run = this.run.bind(this)

    this.state = { at: new Date(), turn: 'wait' }
  }

  componentDidMount() {
    this.initialize()
  }

  componentWillUnmount() {
    this.abortController.abort()
    if (this.timer) { window.clearTimeout(this.time) }
  }

  async initialize() {
    const that = this
    await that.run()
  }
  
  async run() {
    const that = this
    const curAt = new Date()

    await new Promise(r => that.setState({ turn: 'wait' }, r))
    await new Promise(r => window.setTimeout(r, 600))
    await new Promise(r => that.setState({ at: curAt, turn: 'done' }, r))

    if (this.timer) { window.clearTimeout(this.time) }
    this.timer = window.setTimeout(that.run, 1000 * 180)
  }

  render() {
    const { name, target } = this.props
    const { turn, at } = this.state
    const mt = moment(at)

    let items = name ? [name] : []

    if (!target || target === 'aboluted') {
      const aboluted = ['bitcoin', 'ethereum', 'coinbase', 'binance', 'krakenfx', 'opensea', 'uniswap', 'Grayscale']
      items.push(...aboluted)
    }
    if (target === 'speical') {
      items = ['jack', 'vitalikbuterin', 'elonmusk', 'saylor', 'brian_armstrong', 'barrysilbert', 'cz_binance', 'iohk_charles', 'sonnenshein', 'bgarlinghouse', 'justinsuntron']
    }
    if (target === 'media') {
      items = ['hankyungmedia', 'BitcoinMagazine', 'yahoofinance', 'tokenpostkr', 'with_blockmedia']
    }

    return (
      <Container>
        {at && (!target || target === 'aboluted') ? (
          <>
            <Header>
              <div className="lead">
                <strong style={{ marginRight: '0.35rem' }}>
                  <span style={{ marginRight: '0.1rem' }}>{mt.format('MM')}.</span>
                  <span>{mt.format('DD')}</span>
                </strong>
                <small style={{ marginRight: '0.35rem' }}>
                  <span style={{ marginRight: '0.1rem' }}>{mt.format('HH')}시</span>
                  <span style={{ marginRight: '0.1rem' }}>{mt.format('mm')}분</span>
                </small>
                <small>
                  <strong>{mt.format('dddd')}</strong>
                </small>
              </div>
              <div className="desc">
                해당 트위터 뉴스라인은 <strong>180초 뒤에 자동 새로고침</strong> 됩니다.
              </div>
            </Header>
          </>
        ) : null}
        <Box.Group>
          {turn === 'done'
            ? items.map((name, idx) => {
              const dataSource = { sourceType: "profile", screenName: name }
              const options = { chrome: "noheader, nofooter", theme: "dark", width: sizes.w, height: sizes.h }
              const twitterProps = { dataSource, options }
              return (
                <Box key={`twitter_${idx}`} className="animate__animated animate__fadeInLeft" style={{ animationDelay: `${idx * 0.6}s` }}>
                  <TwitterTimeline {...twitterProps} />
                </Box>
              )
            })
            : null}
        </Box.Group>
      </Container>
    )
  }
}

export default LiveTwittersWidget

